import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

export async function getAdminDetails() {
  try {
    const responseData = await authenticatedFetch(`${URL.adminApi}`, {
      method: "GET",
    });

    return responseData;
  } catch (error) {
    console.error("Error fetching admin details:", error.message);
    throw error;
  }
}